import { render } from "./HistoriqueTelechargementPage.vue?vue&type=template&id=7fad01e6&ts=true"
import script from "./HistoriqueTelechargementPage.vue?vue&type=script&lang=ts"
export * from "./HistoriqueTelechargementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__